<template>
  <section>
    <div class="container">

      <div class="table-box">
        <calendar-component></calendar-component>
      </div>
    </div>
  </section>
</template>

<script>
let page_name="calendar"
import {calendar} from "@/api/public.js"
import calendarComponent from "@/views/components/calendar.vue"
export default {
  name: "calendar",
  components:{calendarComponent},

  data() {
    return {
      date: [],
      params:{
        'day':''
      }
    };
  },

  mounted(){
    this.admin_permission = this.$store.state.permission.permissionArr[page_name]
    this.getCalendar()
  },

  methods: {
    getCalendar() {
      calendar(this.params).then(res=>{
        if(res.code === 200){
          this.date = res.data
        }
      })
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/static/default";
.el-drawer {
  overflow: auto !important;
}
.users {
  width: 100%;
  background-color: white;
  padding: 10px 50px;
  // padding-left: 50px;
}
.container {
  width: 100%;
  height: 100%;
  background-color: #fff !important;
  box-sizing: border-box;
  padding: 20px;
  padding-bottom: 0;
  display: inline-flex;
  flex-flow: column;
  justify-content: space-between;
  .search-box{
    width: 100%;
    flex-shrink: 0;
    display:inline-flex;
    .control-box-input{
      width: 200px;
    }
  }
  .table-box{
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding-top: 10px;
    flex-shrink: 1;
    display:inline-flex;
    flex-flow: column;
    justify-content: space-between;
    .el-tabs__header{
      margin: 0 !important;
    }
  }

  .toolbar {
    background: #fff;
    width: 100%;
    padding: 16px 32px 26px 0;
  }
}

.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>